// extracted by mini-css-extract-plugin
module.exports = {"boxButton":"FeedbackOptions_boxButton__3ZEqF","button":"FeedbackOptions_button__21YTU"};